import React from 'react';
import { useController } from 'react-hook-form';
import required from './required';

const HorizontalFormInput = ({
  name,
  control,
  className,
  id,
  label,
  type = 'text',
  placeholder,
  renderAs,
  rows,
  maxlength,
  helpText,
  disabled,
  rules
}) => {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error, isTouched }
  } = useController({
    name,
    control,
    rules: rules !== undefined ? rules : required
  });

  const inputClass = `${className} ${
    error && isTouched ? 'form-control--has-error' :
    isTouched && value && !error ? 'form-control--has-success' : ''
  }`;

  return (
    <div className='form-group form-group--horizontal'>
      <div>
        <label htmlFor={id || name} className="label">{label}</label>
      </div>
      <div>
        {renderAs === 'textarea' ? (
          <textarea
            ref={ref}
            value={value || ''}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            className={inputClass}
            id={id || name}
            name={name}
            rows={rows}
            maxLength={maxlength}
            disabled={disabled}
          />
        ) : (
          <input
            ref={ref}
            value={value || ''}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            type={type}
            className={inputClass}
            id={id || name}
            name={name}
            disabled={disabled}
            maxLength={maxlength}
          />
        )}

        {error ? (
          <span className='help-text help-text--has-error'>{error.message}</span>
        ) : helpText && (
          <span className="help-text">{helpText}</span>
        )}
      </div>
    </div>
  );
};

export default HorizontalFormInput;